import { useMutation } from "react-query";
import { CreateProjectPayload } from "../../Interfaces/FeatureFlip";
import paths from "API/paths";
import axiosInstance from "Services/axiosConfig";

const createProject = async (payload: CreateProjectPayload) => {
  try {
    const url = paths.createProject();
    const response = await axiosInstance.post(url, { input: payload });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const useCreateProject = () => {
  return useMutation(createProject);
};
